export interface AdminAccountPaymentExemptionUpdateRequestModel {
  paymentExempted: boolean;
}
